import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { finalize, takeUntil } from 'rxjs/operators';
import { FormsModule, UntypedFormGroup } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { FireBaseService } from '../../../services/fire-base.service';
import { LoaderService } from '../../../services/loader.service';
import { BaseComponent } from '../../base/base.component';
import { CommonModule } from '@angular/common';
import { UserAccount } from '../../../types/user';
import { OtpInputComponent } from '../../otp-input.component/otp-input.component';
import { ResendVerificationCodeComponent } from '../../resend-verification-code/resend-verification-code.component';
import { KeysOtpPipe } from '../../../pipes/key-otp.pipe';
import { StorageService } from '../../../services/storage.service';
import { RESY_TOKEN } from '../../../constants/storage-keys';
import { PopupService } from '../../../services/popup.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    OtpInputComponent,
    ResendVerificationCodeComponent,
    RouterModule,
    FormsModule,
  ],
  providers: [KeysOtpPipe],
})
export class VerificationComponent extends BaseComponent implements OnInit {
  @Input() isMobile = true;
  public phoneNumber = '';
  public inputsQuantity = 6;
  public buttonIsDisabled = true;
  public otpForm: UntypedFormGroup;
  private loginLoader = false;
  public verificationCode: string;
  public verifyError = false;
  public code = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private fireBaseService: FireBaseService,
    private storageService: StorageService,
    private loaderService: LoaderService,
    private popupService: PopupService
  ) {
    super();
  }

  ngOnInit() {
    this.phoneNumber = this.activatedRoute.snapshot.params.phoneNumber;
    this.otpForm = new UntypedFormGroup({});
  }

  public verifyAndLogIn($event): void {
    $event.preventDefault();
    if (!this.buttonIsDisabled && !this.loginLoader) {
      this.loginLoader = true;
      this.loaderService.show();
      this.fireBaseService
        .confirm(this.verificationCode)
        .then((userCredential) => userCredential.user.getIdToken())
        .then((token) =>
          this.authService
            .login(token)
            .pipe(
              takeUntil(this.unsubscribe$),
              finalize(() => {
                this.loginLoader = false;
                this.loaderService.hide();
              })
            )
            .subscribe((userAccount: UserAccount) =>
              this.handleNavigate(userAccount)
            )
        )
        .catch((err) => {
          this.loginLoader = false;
          this.loaderService.hide();
          this.verifyError = true;
          this.popupService.showErrorResponsePopup(err.message);
          console.error(err);
        });
    }
  }

  inputValueChange($event: string) {
    this.verifyError = false;
    if ($event?.length === 6) {
      this.verificationCode = $event;
      this.buttonIsDisabled = false;
    } else {
      this.buttonIsDisabled = true;
    }
  }

  private handleNavigate(userAccount: UserAccount): void {
    const resyToken = this.storageService.getFromStorage(RESY_TOKEN);
    if (resyToken) {
      this.router.navigateByUrl('/my/welcome-drinks');
      return;
    }
    const ticketId = this.storageService.getFromStorage<string>('ticketId');
    const redirectUrl = this.authService.redirectUrl ?? '/';

    userAccount.account
      ? this.router.navigateByUrl(
          ticketId ? `/receive/${ticketId}` : redirectUrl
        )
      : this.router.navigateByUrl('/auth/name');
  }
}
